/**
 * Espelha `ViewModel.Swap.SwapSessaoViewModel` do backend.
 *
 * Retornado por:
 *  - `PR_SWAP_SESSAO_CONSULTA`       (listagem; preenche `numControle`).
 *  - `PR_SWAP_SESSAO_CONSULTA_ITEM`  (detalhe;  `numControle` vem nulo).
 *
 * As imagens (`IMG_BOMBA` / `IMG_PAINEL` / `IMG_PLACA`) NÃO vêm aqui —
 * apenas as flags `flgImg*` indicam se foram enviadas. Para baixar o
 * conteúdo binário será necessário um endpoint dedicado.
 */
export interface SwapSessao {
  /** Sequencial dentro da página (somente listagem). */
  numControle?: number | null;

  codSessao?: number | null;
  sessionId?: string | null;

  /** ISO datetime. */
  dthCriacao?: string | null;
  /** ISO datetime. */
  dthUltAtividade?: string | null;
  flgEncerrada?: boolean | null;
  etapa?: string | null;

  codMotorista?: number | null;
  numTelMotorista?: string | null;
  numCpfMotorista?: string | null;
  /**
   * Nome do motorista. Regras do backend:
   *  - `codMotorista` null → ''
   *  - encontrado → nome real
   *  - não encontrado → 'Invalido - {codigo}'.
   */
  dscNomeMotorista?: string | null;

  codFrota?: number | null;
  codVeiculo?: number | null;
  dscPlaca?: string | null;

  codProduto?: number | null;
  cdProduto?: string | null;
  /**
   * Cartão formatado. Regras do backend:
   *  - `codProduto` null → ''
   *  - LAST4 encontrado → 'xxxx {LAST4}' (ex.: 'xxxx 0035')
   *  - não encontrado → 'Invalido - {codigo}'.
   */
  dscCartao?: string | null;
  /**
   * Descrição do combustível. Regras do backend:
   *  - `cdProduto` null/vazio → ''
   *  - encontrado → descrição real
   *  - não encontrado → 'Invalido - {codigo}'.
   */
  dscCombustivel?: string | null;

  vlrPrecoUnitario?: number | null;
  numKm?: number | null;
  vlrMinimo?: number | null;
  vlrMaximo?: number | null;

  jsonFrotasCandidatas?: string | null;
  dscSessionExterna?: string | null;

  flgAutorizado?: boolean | string | number | null;
  codAutorizacao?: string | null;
  vlrAutorizado?: number | null;
  /**
   * Indica se bypass é permitido na UI (origem na proc: `HabilitaByPass`,
   * derivado de `ERRO.FLG_PERMITE_BYPASS = 'S'`). No JSON da API costuma vir
   * como `habilitaByPass` (camelCase).
   */
  habilitaByPass?: boolean | null;

  /** Código do erro de auditoria (sessão ou `AUTORIZACAO.COD_ERRO_AUDITORIA`). */
  codErroAuditoria?: string | null;
  /**
   * Mensagem de auditoria: `SWAP_SESSAO.MSG_ERRO_AUDITORIA` ou
   * `AUTORIZACAO.DSC_RESTRICAO_AUDITORIA` (`PR_SWAP_SESSAO_CONSULTA`).
   */
  msgErroAuditoria?: string | null;

  /**
   * Código MCC (`CTFCARD..AUTORIZACAO.COD_MCC`), via `COD_AUTORIZACAO` ou `COD_ABASTECIMENTO`.
   */
  codMcc?: string | null;
  /** Descrição do MCC (`TIPO_MCC_COMPLETA` / coluna `DSC_MCC` da proc). */
  dscMcc?: string | null;

  /**
   * Código do posto. Procs devolvem `COD_POSTO`; o ViewModel C# expõe `CodPosto`
   * (JSON em camelCase `codPosto`).
   */
  codPosto?: string | null;
  CodPosto?: string | null;

  /**
   * Nome do posto. Procs devolvem `PA7_NOME`; o ViewModel C# expõe `NomePosto`
   * (`nomePosto` no JSON). Aceita também chaves legadas em mocks.
   */
  nomePosto?: string | null;
  NomePosto?: string | null;

  /** ISO datetime. */
  datValidadePreautorizacao?: string | null;
  codAbastecimento?: number | null;
  qtdVolume?: number | null;
  vlrTotal?: number | null;

  /** True se a imagem da bomba foi enviada. */
  flgImgBomba: boolean;
  /** True se a imagem do painel foi enviada. */
  flgImgPainel: boolean;
  /** True se a imagem da placa foi enviada. */
  flgImgPlaca: boolean;

  /** ISO datetime. */
  datMotUltimoAbast?: string | null;
  internalTransactionId?: string | null;
}
